export default __webpack_public_path__ + "static/media/sortingIconAscending.85c6404f.svg";